import { API_CALL } from 'actions/actionConstants'
import { FETCH_TOUR_FLIGHT_AIRPORTS } from 'actions/apiActionConstants'
import type { AppAction } from 'actions/types/ActionTypes'
import getTourFlightAirports from 'api/tour/getTourFlightAirports'
import getTourFlightAirportsKey from 'checkout/lib/getTourFlightAirportsKey'

export default function fetchTourFlightAirports(tourId: string, departureId: string): AppAction {
  return (dispatch, getState) => {
    const key = getTourFlightAirportsKey(tourId, departureId)
    const current = getState().tour.tourFlightAirports[key]
    if (current?.data || current?.fetching) return

    dispatch({
      type: API_CALL,
      api: FETCH_TOUR_FLIGHT_AIRPORTS,
      request: () => getTourFlightAirports(tourId, departureId),
      key,
    })
  }
}
